{
    "Accessibility Menu": "접근성 메뉴",
    "Reset settings": "설정 초기화",
    "Close": "닫기",
    "Content Adjustments": "컨텐츠 조정",
    "Adjust Font Size": "글꼴 크기 조정",
    "Highlight Title": "제목 강조",
    "Highlight Links": "링크 강조",
    "Readable Font": "읽기 쉬운 글꼴",
    "Color Adjustments": "색상 조정",
    "Dark Contrast": "어두운 대비",
    "Light Contrast": "밝은 대비",
    "High Contrast": "높은 대비",
    "High Saturation": "높은 채도",
    "Low Saturation": "낮은 채도",
    "Monochrome": "단색",
    "Protanopia": "적색맹",
    "Deuteranopia": "녹색맹",
    "Tritanopia": "청색맹",
    "Visual & Navigation Aids": "시각 및 탐색 보조",
    "Additional Tools": "추가 도구",
    "Reading Guide": "읽기 가이드",
    "Stop Animations": "애니메이션 중지",
    "Big Cursor": "큰 커서",
    "Screen Reader": "화면 낭독기",
    "Hide Images": "이미지 숨기기",
    "Image Tooltips": "이미지 툴팁",
    "Page Structure": "페이지 구조",
    "Super Focus": "슈퍼 포커스",
    "Magnifier": "돋보기",
    "Increase Font Size": "글꼴 크기 증가",
    "Decrease Font Size": "글꼴 크기 감소",
    "Letter Spacing": "자간",
    "Line Height": "줄 간격",
    "Font Weight": "글꼴 두께",
    "Dyslexia Font": "난독증 글꼴",
    "Language": "언어",
    "Open Accessibility Menu": "접근성 메뉴 열기",
    "Accessibility Profiles": "접근성 프로필",
    "Seizure Safe Profile": "발작 안전 프로필",
    "Stops animations and reduces color saturation.": "애니메이션을 중지하고 색상 채도를 낮춥니다.",
    "Blind Profile": "시각 장애인 프로필",
    "Activates the screen reader for auditory navigation.": "청각 탐색을 위해 화면 낭독기를 활성화합니다.",
    "Visually Impaired Profile": "저시력 프로필",
    "Enhances contrast and readability for low vision.": "저시력을 위한 대비와 가독성을 향상시킵니다.",
    "ADHD Friendly Profile": "ADHD 친화 프로필",
    "Reduces distractions for better focus.": "더 나은 집중을 위해 방해 요소를 줄입니다.",
    "Cognitive & Learning Profile": "인지 및 학습 프로필",
    "Helpful tools for reading and comprehension.": "읽기와 이해를 위한 유용한 도구들.",
    "Motor Impaired Profile": "운동 장애 프로필",
    "Optimizes the site for keyboard-only navigation.": "키보드 전용 탐색을 위해 사이트를 최적화합니다.",
    "Headings": "제목",
    "Landmarks": "랜드마크",
    "Links": "링크",
    "Focus element": "요소 포커스",
    "Visit link": "링크 방문"
}
